import React, { useEffect } from 'react';
import { Select } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';

import textTemplateActions from 'actions/text_templates';
import emailTemplateActions from 'actions/email_templates';
import { ClippedContent } from 'dyl-components';
import './TemplateSelector.scss';

export const TEMPLATE_TYPES = { SMS: 'text', EMAIL: 'email' };

const ACTIONS = {
    text: textTemplateActions,
    email: emailTemplateActions
};

export const TemplateSelector = ({
    header = 'Select Template',
    fluid = true,
    selectedTemplate,
    templates = [],
    onChange,
    isReadingTemplates,
    disabled
}) => (
    <Select
        selectOnBlur={false}
        selectOnNavigation={false}
        value={selectedTemplate}
        name='template'
        options={templates}
        fluid={fluid}
        onChange={onChange}
        header={header}
        placeholder={header}
        loading={isReadingTemplates}
        clearable
        className='TemplateSelector'
        disabled={disabled}
    />
);

const TemplateSelectorContainer = ({
    type,
    selectedTemplate,
    onChange,
    header,
    fluid,
    disabled
}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(ACTIONS[type].getTemplates());
    }, [dispatch, type]);

    const templatesState = useSelector(state => state[`${type}_templates`]);
    const templates = templatesState.templates.map(template => ({
        key: template.id,
        value: template.id,
        text: template.name,
        content: (
            <ClippedContent>
                {template.name}
            </ClippedContent>
        )
    }));
    const isReadingTemplates = templatesState.isReadingTemplates;

    return (
        <TemplateSelector
            header={header}
            fluid={fluid}
            selectedTemplate={selectedTemplate}
            templates={templates}
            onChange={onChange}
            isReadingTemplates={isReadingTemplates}
            disabled={disabled}
        />
    );
};

export default TemplateSelectorContainer;
